<div class="main row">
  <ds-confirmation [confirmationData]="confirmationData">
    <ds-confirmation-link-area>
      @if (showGetAnotherQuote$ | async) {
        <button
          ds-button
          class="-outline -white margin-right-30 capitalize"
          (click)="getAnotherQuote()"
          aria-label="Get Another Quote"
        >
          Get Another Quote
        </button>
      }
      <a class="font-weight-semibold" href="javascript:void(0);" (click)="backToVehicleDetails()"
        >Back To Vehicle Details</a
      >
    </ds-confirmation-link-area>
  </ds-confirmation>
</div>
